import DesignSelection from "../components/DesignSelection";
import { HomeHeroImage, HomeHeroRow, HomeHeroText, HomeHeroCTO, Story, Details, GraphicPosition, UPF50, ButtonLink } from "../styles";
import { IconLogo } from "../svgs";
import { ASSET_URL } from "../constants";

const Home = () => {
  return (
    <>
      <>
        <HomeHeroImage>
          <picture className="banner-mobile">
            <source srcset={`${ASSET_URL}/banners/avif/banner-mobile.avif`} type="image/avif" />
            <img src={`${ASSET_URL}/banners/banner-mobile.jpg`} />
          </picture>
          <picture className="banner-tablet">
            <source srcset={`${ASSET_URL}/banners/avif/banner-tablet.avif`} type="image/avif" />
            <img src={`${ASSET_URL}/banners/banner-tablet.jpg`} />
          </picture>
          <picture className="banner-desktop">
            <source srcset={`${ASSET_URL}/banners/avif/banner-desktop.avif`} type="image/avif" />
            <img src={`${ASSET_URL}/banners/banner-desktop.jpg`} />
          </picture>
        </HomeHeroImage>
        <HomeHeroRow>
          <HomeHeroText>
            <div className="hero-text-top">
              <span className="upf50-logo">
                <span>UPF</span>50+
              </span>
              <span className="upf50-text">active graphic tees</span>
            </div>
            <span className="hero-text-bottom">for your next outdoor adventure</span>
          </HomeHeroText>
        </HomeHeroRow>
        <Story>
          <IconLogo className="logo" />
          <h2>
            Stay cool, comfortable, and fully protected from harmful UV rays with our UPF50+ Active Graphic Tee. Crafted from a
            moisture-wicking fabric that mimics the soft touch of cotton, this shirt offers ultimate protection without sacrificing comfort.
          </h2>
        </Story>
        <Details>
          <div id="more-info" className="details-content">
            <h3>Designed for the Outdoors</h3>
            <p>
              Whether you're hiking, enjoying outdoor sports, relaxing in the sun or spending the day by the water, the moisture-wicking
              fabric helps you stay cool, dry and protected from harmful rays, while the relaxed fit allows for full range of motion keeping
              you safe and comfortable all day long.
            </p>
            <h3 className="available-size-title">Available in Short Sizes</h3>
            <p>
              Our unisex shirts are made for everyone, with regular and short sizing options so you can find the perfect fit no matter your
              height or body type. Designed to work for all genders, these tees are soft and built for everyday comfort. Choose a classic
              length or a shorter fit for a look that suits your style.
            </p>
          </div>
          <div className="details-graphic">
            <div className="designed-for-outdoors"></div>
            <div className="homepage-size-chart">
              <div>
                <p>SIZES</p>
                <div className="homepage-size-chart-columns">
                  <div className="homepage-size-chart-column">
                    <div className="size-heading short">
                      <span className="short">Short</span>
                    </div>
                    <div className="size-values short">
                      <ul>
                        <li>XS</li>
                        <li>SM</li>
                        <li>MD</li>
                        <li>LG</li>
                        <li>XL</li>
                      </ul>
                    </div>
                  </div>

                  <div className="homepage-size-chart-column">
                    <div className="size-heading reg">
                      <span className="regular">Regular</span>
                    </div>
                    <div className="size-values reg">
                      <ul>
                        <li>SM</li>
                        <li>MD</li>
                        <li>LG</li>
                        <li>XL</li>
                        <li>XXL</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <ButtonLink to="/size-guide" className="autoFitCenter white">
                view size guide
              </ButtonLink>
            </div>
          </div>
        </Details>
        <UPF50>
          <div className="UPF50-infographic">
            <span className="upf50-logo">
              <span>UPF</span>50+
            </span>
            <span className="upf50-title">actively protect your skin from harmful UVA & UVB rays</span>
            <div className="upf-table">
              <div className="upf-row upf-table-header">
                <div className="upf-column">UPF RATING</div>
                <div className="upf-column">%UV RAYS BLOCKED</div>
              </div>
              <div className="upf-row poor">
                <div className="upf-column">5 - 14</div>
                <div className="upf-column">80 - 93</div>
              </div>
              <div className="upf-row good">
                <div className="upf-column">15 - 24</div>
                <div className="upf-column">93 - 96</div>
              </div>
              <div className="upf-row better">
                <div className="upf-column">25 - 39</div>
                <div className="upf-column">96 - 97</div>
              </div>
              <div className="upf-row best">
                <div className="upf-column">40 - 50+</div>
                <div className="upf-column">97 - 98+</div>
              </div>
            </div>
          </div>
          <div className="UPF50-content">
            <h3>What is UPF?</h3>
            <p>
              UPF or Ultraviolet Protection Factor is a rating system used to measure the effectiveness of sun protection fabrics. The
              higher the UPF, the more protection the fabric provides you from the sun. A UPF of 50 means only 1/50th of the sun's UV rays
              will reach the skin. This means that your skin will be 98% covered from harmful UVA and UVB radiation.
            </p>
            <h3 className="cotton">What about cotton clothing?</h3>
            <p>
              An average white cotton t-shirt has a UPF rating of 5 letting 20% of the suns harmful UV rays pass through the garment. This
              is equivalent to wearing SPF5 sunscreen. When wet, the UPF can drop even lower and allow even more UV rays through.
            </p>
          </div>
        </UPF50>
        <GraphicPosition>
          <div className="details-graphic">
            <img src={`${ASSET_URL}/banners/front-design.jpg`} role="presentation" />
            <img src={`${ASSET_URL}/banners/back-design.jpg`} role="presentation" />
          </div>
          <div className="details-content">
            <h3>Graphic Placement Options</h3>
            <p>
              Our shirts are customizable allowing you to choose your style, whether you prefer your graphic on the front for maximum
              visibility or on the back for a more subtle look.
            </p>
            <p>Check out our gallery for more visuals.</p>
            <ButtonLink className="autoFitCenter" to="/gallery">
              view gallery
            </ButtonLink>
          </div>
        </GraphicPosition>
      </>
      <DesignSelection />
    </>
  );
};

export default Home;
